/**
 * Enumeration of the response headers we care about from task service
 * NOTE: Headers are officially case-insensitive. But its common practice to captialize first letter of each word.
 */ export var TaskServiceResponseHeaders = /*#__PURE__*/ function(TaskServiceResponseHeaders) {
    /** The client side correlation id */ TaskServiceResponseHeaders["XCorrelationId"] = "X-CorrelationId";
    /** Tasks Platform Service generated correlation id per request */ TaskServiceResponseHeaders["TCorrelationId"] = "X-Tasks-CorrelationId";
    TaskServiceResponseHeaders["ProxyFE"] = "X-ProxyFE";
    TaskServiceResponseHeaders["ProxyCluster"] = "X-ProxyCluster";
    TaskServiceResponseHeaders["ProxyVersion"] = "X-ProxyVersion";
    TaskServiceResponseHeaders["OfficeFE"] = "X-OfficeFE";
    TaskServiceResponseHeaders["OfficeVersion"] = "X-OfficeVersion";
    TaskServiceResponseHeaders["OfficeCluster"] = "X-OfficeCluster";
    /** This is the AFD header that tells us which AFD node you were routed to as well as having their equivalent of a correlation id */ TaskServiceResponseHeaders["EdgeRef"] = "X-MSEdge-Ref";
    /** User Session id */ TaskServiceResponseHeaders["UserSession"] = "X-UserSessionId";
    /** Response header for the authentication failure challenge */ TaskServiceResponseHeaders["AuthenticationChallenge"] = "WWW-Authenticate";
    /** The reason phrase for authentication failure */ TaskServiceResponseHeaders["ReasonPhrase"] = "ReasonPhrase";
    /** The tasks service operation id */ TaskServiceResponseHeaders["OperationId"] = "X-Planner-Operationid";
    return TaskServiceResponseHeaders;
}({});
/**
 * Enumeration of the response headers we care about from from Planner (Unified) Api
 */ export var PlannerServiceResponseHeaders = /*#__PURE__*/ function(PlannerServiceResponseHeaders) {
    /** The planner service operation id */ PlannerServiceResponseHeaders["OperationId"] = "MS-Planner-Operationid";
    /** The location header for the long running operation */ PlannerServiceResponseHeaders["LocationHeader"] = "location";
    return PlannerServiceResponseHeaders;
}({});
/**
 * Constants used by the service and locally for object diffs
 */ export class ObjectDiffConstants {
}
/** Value used when a collection property is cleared of values */ ObjectDiffConstants.CollectionCleanupValue = "RemoveAll";
/**
 * Http Request Type
 * Enumeration of the response headers we care about from graph
 */ export var GraphResponseHeaders = /*#__PURE__*/ function(GraphResponseHeaders) {
    /** The client side correlation id tracking a request */ GraphResponseHeaders["ClientRequestId"] = "client-request-id";
    /** The graph generated correlation id*/ GraphResponseHeaders["RequestId"] = "request-id";
    /** Tasks Platform Service generated correlation id per request */ GraphResponseHeaders["TCorrelationId"] = "X-Tasks-CorrelationId";
    /** Sharepoint correlation ID */ GraphResponseHeaders["SpLogId"] = "splogid";
    return GraphResponseHeaders;
}({});
/**
 * Enumeration of the response headers we care about from Loop
 */ export var LoopResponseHeaders = /*#__PURE__*/ function(LoopResponseHeaders) {
    /** Loop generated correlation vector per request */ LoopResponseHeaders["CorrelationVector"] = "MS-CV";
    return LoopResponseHeaders;
}({});
/**
 * Enumeration of the response headers we care about from OCPS
 */ export var OcpsResponseHeaders = /*#__PURE__*/ function(OcpsResponseHeaders) {
    /** OCPS generated correlation id per request */ OcpsResponseHeaders["CorrelationId"] = "x-cid";
    return OcpsResponseHeaders;
}({});
/**
 * Enumeration of the request headers
 */ export var RequestHeaders = /*#__PURE__*/ function(RequestHeaders) {
    /** The client side correlation id tracking a request (graph) */ RequestHeaders["ClientRequestId"] = "client-request-id";
    /** Similar to ClientRequestId, specifies the correlation id (web api) */ RequestHeaders["XCorrelationId"] = "X-CorrelationId";
    /** Header that indicates what page Planner is on */ RequestHeaders["PlannerUsageViewName"] = "X-Planner-Usage";
    /** Header that indicates the Planner client type */ RequestHeaders["PlannerUsageClientType"] = "X-Planner-ClientType";
    /** Header for a user session */ RequestHeaders["UserSessionIdHeaderName"] = "X-UserSessionId";
    /** This header will set routing on ajax calls */ RequestHeaders["PlannerRouteHintHeaderName"] = "X-PlannerRouteHint";
    return RequestHeaders;
}({});
/**
 * Enumeration of the request headers for task platform
 */ export var TaskPlatformRequestHeaders = /*#__PURE__*/ function(TaskPlatformRequestHeaders) {
    /** The header that indicates the client type to the tasks platform */ TaskPlatformRequestHeaders["TasksClientType"] = "X-Tasks-ClientType";
    /** The header that indicates the client usage to the tasks platform */ TaskPlatformRequestHeaders["TasksClientUsage"] = "X-Tasks-ClientUsage";
    return TaskPlatformRequestHeaders;
}({});
/**
 * Project telemetry headers
 */ export const ProjectClientType = "x-project-client-type";
export const ProjectClientFlavor = "x-project-client-flavor";
/**
 * Enumeration of the response headers we care about from the Project Scheduling Service (PSS)
 */ export var PSSResponseHeaders = /*#__PURE__*/ function(PSSResponseHeaders) {
    /** The client side correlation id tracking a request */ PSSResponseHeaders["ClientRequestId"] = "client-request-id";
    /** PSS generated correlation id per request */ PSSResponseHeaders["XCorrelationId"] = "x-correlationid";
    /** PSS header capturing the project cloudproj service (PCS) session identifier */ PSSResponseHeaders["ProjectSessionId"] = "x-project-session-id";
    return PSSResponseHeaders;
}({});
/**
 * Enumeration of the response headers we care about from the Project LandingPage Service (PLP)
 */ export var PLPResponseHeaders = /*#__PURE__*/ function(PLPResponseHeaders) {
    /** The client side correlation id tracking a request */ PLPResponseHeaders["ClientRequestId"] = "client-request-id";
    /** PLP generated correlation id per request */ PLPResponseHeaders["XCorrelationId"] = "x-correlationid";
    return PLPResponseHeaders;
}({});
/**
 * Enumeration of the values from response header ReasonPhrase which contains more information on failure data
 */ export var AuthenticationReasonPhrase = /*#__PURE__*/ function(AuthenticationReasonPhrase) {
    /** Value indicates an authentication challenge error and we require to re-sign the current user */ AuthenticationReasonPhrase["InteractionRequired"] = "interaction_required";
    return AuthenticationReasonPhrase;
}({});
/**
 * Enumeration for the 'error' content for the WWW-Authenticate response header
 */ export var AuthenticationChallengeResponseErrors = /*#__PURE__*/ function(AuthenticationChallengeResponseErrors) {
    /** Value for insufficient claims */ AuthenticationChallengeResponseErrors["InsufficientClaims"] = "insufficient_claims";
    return AuthenticationChallengeResponseErrors;
}({});
/**
 * Enumeration of the response headers we care about from the Gateway Service
 */ export var GatewayServiceResponseHeaders = /*#__PURE__*/ function(GatewayServiceResponseHeaders) {
    /** The client side correlation id tracking a request */ GatewayServiceResponseHeaders["ClientRequestId"] = "client-request-id";
    /** Gateway Service generated correlation id per request */ GatewayServiceResponseHeaders["XCorrelationId"] = "x-correlationid";
    /** Gateway service header capturing the session identifier */ GatewayServiceResponseHeaders["ProjectSessionId"] = "x-project-session-id";
    return GatewayServiceResponseHeaders;
}({});
/**
 * Enumeration of the additional response headers for RetailServices
 */ export var RetailServicesResponseHeaders = /*#__PURE__*/ function(RetailServicesResponseHeaders) {
    /** Retail service correlation id */ RetailServicesResponseHeaders["CorrelationId"] = "x-ms-correlation-id";
    return RetailServicesResponseHeaders;
}({});
/**
 * Enumeration of the additional request headers for RetailServices
 */ export var RetailServicesRequestHeaders = /*#__PURE__*/ function(RetailServicesRequestHeaders) {
    /** The Teams client ring override currently in effect in session */ RetailServicesRequestHeaders["XRingOverride"] = "X-RingOverride";
    return RetailServicesRequestHeaders;
}({});
/**
 * Enumeration of the request headers for LoopService
 */ export var LoopServiceRequestHeaders = /*#__PURE__*/ function(LoopServiceRequestHeaders) {
    /** The correlation vector */ LoopServiceRequestHeaders["MsCv"] = "MS-CV";
    return LoopServiceRequestHeaders;
}({});
/**
 * Enumeration of the request headers for MarsService
 */ export var MarsServiceRequestHeaders = /*#__PURE__*/ function(MarsServiceRequestHeaders) {
    /** Configures whether task execution can respond with broken down tasks. */ MarsServiceRequestHeaders["TaskBreakdownPreference"] = "X-Task-Breakdown-Preference";
    /** The client side correlation id tracking a request */ MarsServiceRequestHeaders["CorrelationId"] = "X-Client-Correlation-Id";
    /** The region of the tenant from which request is made. */ MarsServiceRequestHeaders["TenantRegion"] = "X-Tenant-Region";
    /** The client side user locale */ MarsServiceRequestHeaders["UserLocale"] = "X-Client-User-Locale";
    return MarsServiceRequestHeaders;
}({});
/**
 * Enumeration of the scenarios that can be used in Sharepoint requests
 * These scenarios are used to identify the type of request being made and the context in which it is made
 * They are used to optimize the request handling and routing in Sharepoint service
 */ export var SharepointRequestUserScenarios = /*#__PURE__*/ function(SharepointRequestUserScenarios) {
    /** Scenario for listing out the files in an SPO folder */ SharepointRequestUserScenarios["BrowseFilesGrounding"] = "BrowseFiles_Grounding";
    /** Scenario for creating a new PMA plan */ SharepointRequestUserScenarios["CreateFolderPlanCreation"] = "CreateFolder_PlanCreation";
    /** Scenario for deleting a shortcut file in the plan's SPO folder */ SharepointRequestUserScenarios["DeleteFileGrounding"] = "DeleteFile_Grounding";
    /** Scenario for reading the contents of the shortcut file from the plan's SPO folder */ SharepointRequestUserScenarios["DownloadFileGrounding"] = "DownloadFile_Grounding";
    /** Scenario for sharing a file with a Modern Group */ SharepointRequestUserScenarios["ShareFileGrounding"] = "ShareFile_Grounding";
    /** Scenario for creating a shortcut file in the plan's SPO folder for PMA scenarios */ SharepointRequestUserScenarios["UploadFileGrounding"] = "UploadFile_Grounding";
    /** Scenario for opening a Loop file from the plan's SPO folder */ SharepointRequestUserScenarios["OpenFileLoop"] = "OpenFile_Loop";
    /** Scenario for creating a Whiteboard file in the plan's SPO folder */ SharepointRequestUserScenarios["CreateFileWhiteboard"] = "CreateFile_Whiteboard";
    /** Scenario for listing out the Status Reports files in the Plan's Reports folder */ SharepointRequestUserScenarios["BrowseFilesReports"] = "BrowseFiles_Reports";
    /** Scenario for checking the permissions of a file for PMA grounding scenarios */ SharepointRequestUserScenarios["PermissionCheckGrounding"] = "PermissionCheck_Grounding";
    /** Scenario for checking the sensitivity label of a file for PMA grounding scenarios */ SharepointRequestUserScenarios["SensitivityLabelCheckGrounding"] = "SensitivityLabelCheck_Grounding";
    /** Scenario for deleting a Status Report from the plan's Reports folder */ SharepointRequestUserScenarios["DeleteFileReports"] = "DeleteFile_Reports";
    /** Scenario for setting meta data for a status report from the plan's Reports folder */ SharepointRequestUserScenarios["SetMetaDataReports"] = "SetMetaData_Reports";
    /** Scenario for getting meta data for a status report from the plan's Reports folder */ SharepointRequestUserScenarios["GetMetaDataReports"] = "GetMetaData_Reports";
    /** Scenario for opening a file attachment on task card */ SharepointRequestUserScenarios["OpenFileAttachment"] = "OpenFile_Attachment";
    /** Scenario for uploading a file to the plan's SPO folder - for non-PMA scenarios*/ SharepointRequestUserScenarios["UploadFilePlanner"] = "UploadFile_Planner";
    return SharepointRequestUserScenarios;
}({});
/** Name of the app as expected by Sharepoint service */ export const SharepointAppName = "Planner";
/** Denotes the priority and urgency of the Sharepoint request  */ export var SharepointScenarioType = /*#__PURE__*/ function(SharepointScenarioType) {
    /** This would result in possible data loss if prematurely throttled / missed by the service */ SharepointScenarioType["ActiveUserOperation"] = "AUO";
    /** Completely delayable and the user would minimally notice */ SharepointScenarioType["BackgroundOperation"] = "BGO";
    /** Can either be directly due to a user clicking on something or from general things that need to be called to complete a user experience */ SharepointScenarioType["PassiveOperation"] = "PO";
    return SharepointScenarioType;
}({});
/**
 * Headers used in Sharepoint requests
 * These are used to identify the app, scenario and the priority of the request
 */ export var SharepointHeaders = /*#__PURE__*/ function(SharepointHeaders) {
    /** Represents the name of the application calling the Sharepoint service */ SharepointHeaders["Application"] = "Application";
    /** Represents the user scenario for which the request is made */ SharepointHeaders["Scenario"] = "Scenario";
    /** Represents the priority and urgency of the request */ SharepointHeaders["ScenarioType"] = "ScenarioType";
    return SharepointHeaders;
}({});
/** The English language string returned for MARS unknown language */ export const UNKNOWN_LANGUAGE_STRING = "Unknown language";
/** Mars error code for unsupported language */ export const MARS_ERROR_CODE_UNSUPPORTED_LANGUAGE = "unsupported_language";
/**
 * Http Request Type
 * Enumeration of the response headers we care about from odsp
 */ export var OdspResponseHeaders = /*#__PURE__*/ function(OdspResponseHeaders) {
    /** Request id*/ OdspResponseHeaders["RequestId"] = "SPRequestGuid";
    /** Sharepoint correlation ID */ OdspResponseHeaders["SpLogId"] = "splogid";
    return OdspResponseHeaders;
}({});
